<template>
  <div class="card">
    <div class="card-header" id="headingServices">
      <h5 class="mb-0">
        <button class="btn btn-link collapsed services-collapsed" data-toggle="collapse" aria-expanded="false"
          @click="alterarIcone(`icon-${codigo}-services`, 'service', `${codigo}-services`), buscarServico(codigo)"
          :data-target="`#${codigo}-services`">
          <i :id="`icon-${codigo}-services`" class="fa fa-angle-right" aria-hidden="false"></i>
          <span>{{ descricao }}</span>
        </button>

        <div class="icon-content">
          <i @click="excluirServico(codigo)" style="font-size: 13px !important;float:right"
            class="fa-solid fa-trash trash-icon"></i>
        </div>
        <div class="icon-content">
          <i @click="openModalClonarServico(codigo)" style="font-size: 13px !important;float:right"
            class="fa-solid fa-copy"></i>
        </div>
      </h5>
    </div>

    <div :id="`${codigo}-services`" class="collapse" aria-labelledby="headingServices"
      :data-parent="`accordion-${codigo}-services`">
      <div class="card-body">
        <div :id="`${servicoCampos.idCatalogoApi}`" model="selectedListasServicosCampo"
          v-for="servicoCampos in listaDadosServicoCampos">
          <div class="mt-4">
            <div v-if="codigo === servicoCampos.idServicoApi" class="m-3 textarea-container mt-4">
              <label class="green-label" for="textareaId">Introdução:</label>
              <textarea id="introducao" @input="mudarEstadoInput" @blur="salvarPosFoco"
                :value="servicoCampos.introducao" rows="2">{{ servicoCampos.introducao }}
              </textarea>
            </div>

            <div v-if="codigo === servicoCampos.idServicoApi" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">URL:</label>
              <input id="url" class="input-service" @input="mudarEstadoInput" @blur="salvarPosFoco"
                :value="servicoCampos.url">
            </div>

            <div v-if="codigo === servicoCampos.idServicoApi" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">Método:</label>
              <input id="metodo" class="input-service" @input="mudarEstadoInput" @blur="salvarPosFoco"
                :value="servicoCampos.metodo">
            </div>

            <div v-if="codigo === servicoCampos.idServicoApi" style="margin-left: 5% !important;"
              class="m-0 select-container textarea-container mt-4">
              <input type="hidden" id="idServicoApi" :value="servicoCampos.idServicoApi">
              <label for="exampleSelect" class="green-label">Método HTTP:</label>
              <select @change="mudarRequestType()" class="form-select" id="requestType">
                <option v-if="servicoCampos.requestType === ''" value=" " selected> </option>

                <option v-if="servicoCampos.requestType === 'G'" value="GET" selected>GET</option>
                <option v-if="servicoCampos.requestType != 'G'" value="GET">GET</option>

                <option v-if="servicoCampos.requestType === 'P'" value="POST" selected>POST</option>
                <option v-if="servicoCampos.requestType != 'P'" value="POST">POST</option>

                <option v-if="servicoCampos.requestType === 'T'" value="PUT" selected>PUT</option>
                <option v-if="servicoCampos.requestType != 'T'" value="PUT">PUT</option>

                <option v-if="servicoCampos.requestType === 'D'" value="DELETE" selected>DELETE</option>
                <option v-if="servicoCampos.requestType != 'D'" value="DELETE">DELETE</option>
              </select>
            </div>

            <div v-if="menu === 'S'" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">XML In Inicio:</label>
              <textarea v-model="servicoCampos.codigoXmlInicio" id="codigoXmlInicio" @input="mudarEstadoInput"
                @blur="salvarPosFoco" rows="3" class="text-area-modal">
              </textarea>
            </div>

            <div v-if="menu === 'S'" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">XML In Fim:</label>
              <textarea v-model="servicoCampos.codigoXmlFim" id="codigoXmlFim" @input="mudarEstadoInput"
                @blur="salvarPosFoco" rows="3" class="text-area-modal">
              </textarea>
            </div>

            <div v-if="menu === 'S'" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">XML Out Inicio:</label>
              <textarea v-model="servicoCampos.codigoXmlInicioOut" id="codigoXmlInicioOut" @input="mudarEstadoInput"
                @blur="salvarPosFoco" rows="3" class="text-area-modal">
              </textarea>
            </div>

            <div v-if="menu === 'S'" class="m-4 textarea-container mt-4">
              <label class="green-label" for="textareaId">XML Out Fim:</label>
              <textarea v-model="servicoCampos.codigoXmlFimOut" id="codigoXmlFimOut" @input="mudarEstadoInput"
                @blur="salvarPosFoco" rows="3" class="text-area-modal">
              </textarea>
            </div>

            <SectionTabs :section="sections" :atributos="atributos" :header="headerSection || header"
              :get="getSection || get" :entrada="entradaSection || entrada" :form="formSection || form"
              :body="bodySection || body" :saida="saidaSection || saida" :alerta="alertaSection || alerta"
              :erro="erroSection || erro" v-if="showSectionTabs" :key="sectionTabsKey" :menu="menu"
              :descricao="descricao" :codigoMenu="String(codigoMenu)" :codigo="String(codigo)"
              @onActionUpdate="onActionUpdateInComponent" @onNewSection="onActionNew"
              @onActionAtribute="onActionAtributeInComponent" />
          </div>
        </div>
      </div>
    </div>

        <!-- MODAL CLONAR SERVIÇO -->
     <div v-if="showModalClonarServico" class="modal modal-clonar-servico fade show" tabindex="-1" aria-modal="true" role="dialog" style="display:block;">

      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Clonar serviço</h5>
            <button type="button" class="btn-close" @click="closeModalClonarServico"></button>
          </div>



          <div class="modal-body">
            <div class="col-12 col-sm-12 col-md-3 m-3">
              <div class="form-outline">
                <div class="textarea-container mt-5">
                  <label class="green-label" for="textareaId">Nome do serviço:</label>
                  <input id="nomeMenu" ref="nomeMenu" class="form-control input-modal" v-model.trim="nomeMenu" required>

                </div>
              </div>
            </div>
          </div>


          <div class="m-3 mt-4">
            <div class="row m-1">
              <div class="col-5">
                <button class="footer-button btn btn-primary" style="width: 105% !important;"
                  @click="closeModalClonarServico">
                  CANCELAR
                </button>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <button class="footer-button btn btn-primary active save-btn"
                  style="width: 205% !important;color:white !important" @click="salvarCloneServico()">
                  SALVAR
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
     </div>

  </div>

</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader'
import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';
import SectionTabs from './SectionTabs.vue';

export default {
  name: "ServiceTabs",
  data() {
    return {
      showSectionTabs: true,
      sectionTabsKey: 0,
      clone: false,
      showModal: false,
      showModalAddParametros: false,
      showModalEditParametros: false,
      selectedListasServicos: "",
      selectedListasServicosCampo: "",
      selectedListasServicosAtributos: "",
      requestType: "",
      listaDadosServicos: [],
      listaDadosServicoCampos: [],
      listaDadosServicoAtributos: [],
      listaDadosServicoAtributosHierarquia: [],
      atualDataEditParametros: [],
      atributo: {
        tipo: "",
        nome: "",
        obrigatorio: "",
        formato: "",
        lista: "",
        descricao: "",
        observacao: "",
        idServicoApi: "",
        indexPai: "",
        disabledTipo: false,
      },
      servicoApi: {
        menu: "",
        introducao: "",
        url: "",
        metodo: "",
        requestType: "",
        idCatalogoApi: "",
        codigoMenuPai: ""
      },
      codigoMenuPai: "",
      tempTipo: "",
      tempNome: "",
      tempDescricao: "",
      tempDominio: "",
      tempObservacao: "",
      sections: "",
      atributos: [],
      fluxoTela: [],
      headerSection: false,
      getSection: false,
      entradaSection: false,
      bodySection: false,
      formSection: false,
      saidaSection: false,
      alertaSection: false,
      erroSection: false,
      cloneServico: {
        idOriginal: "",
        idClone: "",
        menuClone: ""
      },
      nomeMenu: "",
      showModalClonarServico: false
    };
  },
  props: {
    titulo: {
      type: String,
      required: false
    },
    descricao: {
      type: String,
      required: false
    },
    codigo: {
      type: String,
      required: true
    },
    codigoMenu: {
      type: String,
      required: false
    },
    subMenu: {
      type: Boolean,
      required: false
    },
    tipo: {
      type: String,
      required: false
    },
    menu: {
      type: String,
      required: false
    },
    fluxoMenu: {
      type: Object,
      required: false
    }
  },
  components: {
    SectionTabs
  },
  computed: {
    header() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'H')
        );
    },
    get() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'G')
        );
    },
    entrada() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'E')
        );
    },
    form() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'F')
        );
    },
    body() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'B')
        );
    },
    get() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'G')
        );
    },
    saida() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'S')
        );
    },
    alerta() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'A')
        );
    },
    erro() {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) &&
          item.atributos.some(attr => attr.entrada === 'W')
        );
    }
  },
  methods: {
    closeModalClonarServico() {
      this.showModalClonarServico = false;
      this.nomeMenu = "";
      this.cloneServico = { idOriginal: "", idClone: "", menuClone: "" };
    },
    async salvarCloneServico() {
      const idServicoApi = this.cloneServico.idOriginal;
      const nomeServico = (this.nomeMenu || "").trim();

      if (!idServicoApi) {
        alertUtils.alertError("ID do serviço não encontrado para clonagem.");
        return;
      }

      if (!nomeServico) {
        alertUtils.alertError("Informe o nome do serviço.");
        return;
      }

      const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/clonar-servico/${idServicoApi}`;

      try {
        this.salvandoCloneServico = true;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "text/plain;charset=UTF-8"
          },
          body: nomeServico
        });

        const result = await response.text();

        if (!response.ok) {
          alertUtils.alertError(result || "Erro ao clonar serviço.");
          return;
        }

        if (result === "CLONE_EXISTS") {
          alertUtils.alertError("Clone já existe!");
          return;
        }

        alertUtils.alertSuccess("Clone criado com sucesso!");
        this.closeModalClonarServico();

        // refresh na lista (padrão que você já usa)
        this.$emit("onAction", this.codigo);

      } catch (e) {
        console.log(e);
        alertUtils.alertError("Erro ao clonar serviço.");
      } finally {
        this.salvandoCloneServico = false;
      }
    },
    async openModalClonarServico(idServicoApi) {
      let servico = (this.listaDadosServicoCampos || []).find(s => s.idServicoApi === idServicoApi);

      if (!servico) {
        servico = await this.buscarServico(idServicoApi);
      }

      this.cloneServico.idOriginal = idServicoApi;


      this.nomeMenu = (servico && servico.menu) ? servico.menu : "";
      this.showModalClonarServico = true;

      this.$nextTick(() => {
        const el = this.$refs.nomeMenu;
        if (el && el.focus) el.focus();
      });
    },
    
    async verificarSections(codigo) {
      return Array.isArray(this.listaDadosServicoAtributosHierarquia) &&
        this.listaDadosServicoAtributosHierarquia.some(item =>
          Array.isArray(item.atributos) && item.atributos.some(attr => attr.entrada === codigo)
        );
    },
    async onActionUpdateInComponent() {
      this.buscarServico(this.codigo);
    },
    async onActionNew(section) {
      switch (section) {
        case "H":
          this.headerSection = true;
          break;
        case "G":
          this.getSection = true;
          break;
        case "E":
          this.entradaSection = true;
          break;
        case "F":
          this.formSection = true;
          break;
        case "B":
          this.bodySection = true;
          break;
        case "S":
          this.saidaSection = true;
          break;
        case "A":
          this.alertaSection = true;
          break;
        case "W":
          this.erroSection = true;
          break;
      }
    },
    async onActionAtributeInComponent(data, atributos) {
      this.sections = data;
      this.atributos = atributos;

      // Aguarde o próximo ciclo para os `computed` reagirem
      await this.$nextTick();

      // Destrói o componente
      this.showSectionTabs = false;

      // Espera o Vue remover do DOM
      await this.$nextTick();

      // Atualiza a chave e recria o componente
      this.sectionTabsKey += 1;
      this.showSectionTabs = true;

      // if(atributos.length < 1) {
      //   // Recarrega a página com a URL modificada
      //   // setTimeout(() => {
      //   //   $('#rest2').click();
      //   // }, 2000);
      // }

      // this.$emit('onAction', 'rest');

      // // Acesse o hash da URL
      // const hash = window.location.hash;

      // // Remova a primeira barra ("/") e separe a string com base nas barras
      // const idCatalogo = hash.split('/').pop();

      // this.pesquisarServicoMenu(idCatalogo, this.codigoMenu);

      // setTimeout(() => {
      //   const targets = [
      //     `#${this.fluxoMenu.menuAcessado}`,
      //     `#${this.fluxoTela.serviceAcessado}`,
      //     `#${data}`
      //   ];

      //   let index = 0;

      //   async function abrirAtributos() {
      //     for (const item of atributos) {
      //       $('#' + item).click();
      //       await new Promise(resolve => setTimeout(resolve, 500)); // Espera 500ms
      //     }
      //   }

      //   function abrirSequencialmente() {
      //     if (index >= targets.length) {
      //       abrirAtributos(); // Chama a função quando terminar
      //       return;
      //     }

      //     const target = targets[index];
      //     const btn = document.querySelector(`button[data-target="${target}"]`);

      //     if (!btn) {
      //       console.warn(`Botão com data-target ${target} não encontrado.`);
      //       index++;
      //       return setTimeout(abrirSequencialmente, 2500);
      //     }

      //     // Abre somente se estiver fechado
      //     if (btn.classList.contains('collapsed') || btn.getAttribute('aria-expanded') === 'true') {
      //       btn.click();
      //     }

      //     index++;
      //     setTimeout(abrirSequencialmente, 2500); // Delay entre aberturas
      //   }

      //   abrirSequencialmente();

      // }, 2500);
    },
    async onActionInComponent() {
      // Acesse o hash da URL
      const hash = window.location.hash;

      // Remova a primeira barra ("/") e separe a string com base nas barras
      const idCatalogo = hash.split('/').pop();

      this.pesquisarServicoMenu(idCatalogo, this.codigo);
    },
    async toggleCollapse(event) {
      // Fecha todos os collapses
      const allCollapses = document.querySelectorAll('.collapse');
      allCollapses.forEach(function (collapse) {
        if (collapse !== document.querySelector(event.target.getAttribute('data-target'))) {
          $(collapse).collapse('hide');
        }
      });

      // Abre o collapse clicado
      const targetCollapse = document.querySelector(event.target.getAttribute('data-target'));
      $(targetCollapse).collapse('toggle');
    },
    async mudarEstadoInput(event) {
      // Quando o valor do input mudar, marca a flag como true
      if (event.target.value !== this.valorAnterior) {
        this.mudou = true;
      }
    },
    async mudarTipo(status, metodo) {
      const formato = metodo === 1 ? 'formatoAdicionar' : 'formato';

      if (status) {
        $(`#${formato}`).prop("disabled", true);

        setTimeout(function () {
          $(`#${formato}`).val('O');
        }, 40);
      } else {
        $(`#${formato}`).prop("disabled", false);

        if (metodo === 1) {
          setTimeout(function () {
            $(`#${formato}`).val('');
          }, 40);
        }
      }
    },
    async validarTipo(selectName) {
      const tipo = $(`#${selectName}`).val();

      const metodo = selectName.includes("Adicionar") ? 1 : 0;

      tipo === 'O' ? this.mudarTipo(true, metodo) : this.mudarTipo(false, metodo);
    },
    async mudarRequestType() {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      await ajaxUtils.postOK(
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
        jsonRequest,
        '',
        ''
      );
    },
    async salvarPosFoco(event) {
      const tipoRequest = $('#requestType').val();
      const idServicoApi = $('#idServicoApi').val();
      const introducao = $('#introducao').val();
      const metodo = $('#metodo').val();
      const url = $('#url').val();

      const codigoXmlFimOut = $('#codigoXmlFimOut').val();
      const codigoXmlInicioOut = $('#codigoXmlInicioOut').val();
      const codigoXmlFim = $('#codigoXmlFim').val();
      const codigoXmlInicio = $('#codigoXmlInicio').val();

      let tipoRequestFormatado = tipoRequest.slice(0, 1).toUpperCase();

      if (tipoRequest === "PUT") tipoRequestFormatado = "T";

      const bodyData = {
        "codigoXmlFimOut": String(codigoXmlFimOut),
        "codigoXmlInicioOut": String(codigoXmlInicioOut),
        "codigoXmlFim": String(codigoXmlFim),
        "codigoXmlInicio": String(codigoXmlInicio),
        "introducao": String(introducao),
        "idServicoApi": String(idServicoApi),
        "url": String(url),
        "metodo": String(metodo),
        "requestType": String(tipoRequestFormatado)
      };

      let jsonRequest;

      jsonRequest = JSON.stringify(bodyData);

      if (this.mudou) {
        await ajaxUtils.postOK(
          '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/salvar-dados-prinicipais-servico',
          jsonRequest,
          '',
          ''
        );

        this.mudou = false; // Resetando a flag
      }
    },
    async removerAtributo(idServicoApi, index) {
      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-atributo/${idServicoApi}/${index}`;

        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Atributo removido com sucesso!");
          this.$emit('onAction', this.codigo);
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao excluir o parâmetro:", error);
      }
    },
    async excluirMenu(codigoMenu) {
      const url = window.location.href;
      const idCatalogo = url.substring(url.lastIndexOf('/') + 1);

      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-menu-catalogo/' + codigoMenu + '/' + String(idCatalogo);

      const requestAjax = await ajaxUtils.postOK(
        urlApi,
        '',
        '',
        ''
      );

      // Remove o item com o código correspondente da lista (refresh)
      this.$emit('onAction', this.codigo); // Emite o código do item que foi excluído

      if (requestAjax) {
        alertUtils.alertSuccess("Menu excluído com sucesso!");
      } else {
        alertUtils.alertSuccess("Erro ao excluir Menu!");
      }

      return requestAjax;
    },
    async excluirServico(idServicoApi) {
      const urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-servico/' + idServicoApi;

      const requestAjax = await ajaxUtils.getOK(
        urlApi,
        '',
        '',
        ''
      );

      // Remove o item com o código correspondente da lista (refresh)
      this.$emit('onAction', this.codigo); // Emite o código do item que foi excluído

      if (requestAjax) {
        alertUtils.alertSuccess("Serviço excluído com sucesso!");
      } else {
        alertUtils.alertSuccess("Erro ao excluir Serviço!");
      }

      return requestAjax;
    },
    async openModalServico(codigo) {
      this.showModal = true;
      this.codigoMenuPai = codigo;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-servico');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async editarNovoParametro() {
      try {
        this.atributo.tipo = this.tempTipo;
        this.atributo.nome = this.tempNome;

        // ID do serviço e índice do pai
        const idServicoApi = this.atributo.idServicoApi;
        const indexPai = this.atributo.ordem;
        const formato = $("#formato").val()
        const payload = {
          entrada: this.atributo.entrada,
          tipo: this.atributo.tipo,
          nome: this.atributo.nome,
          obrigatorio: this.atributo.obrigatorio,
          formato: formato,
          lista: this.atributo.lista,
          descricao: this.atributo.descricao,
          dominio: this.atributo.dominio,
          observacao: this.atributo.observacao
        };

        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/alterar-atributo/${idServicoApi}/${indexPai}`;

        const editarParametro = await ajaxUtils.postOK(
          url,
          JSON.stringify(payload),
          'Parâmetro salvo com sucesso!',
          ''
        );

        if (editarParametro === true) {
          this.closeModal();
          this.$emit('onAction', this.codigo);
        }

        this.$emit('onActionAtribute', 'rest');
      } catch (error) {
        console.error("Erro ao salvar o parâmetro:", error);
      }
    },
    async salvarNovoParametro() {
      try {
        // ID do serviço e índice do pai
        const idServicoApi = this.atributo.idServicoApi;
        const indexPai = this.atributo.indexPai ? this.atributo.indexPai : -1;
        const nome = $('#nomeModalAdicionar').val();
        const descricao = $('#descricaoModalAdicionar').val();
        const tipo = $('#tipoAutenticacaoSelectAdicionar').val();
        let entrada = $('#objetoId').val()

        switch (entrada) {
          case "Header":
            entrada = "H"
            break;
          case "Entrada":
            entrada = "E"
            break;
          case "Get":
            entrada = "G"
            break;
          case "Form":
            entrada = "F"
            break;
          case "Saida":
            entrada = "S"
            break;
          case "Alerta":
            entrada = "A"
            break;
          case "Erro":
            entrada = "W"
            break;
          case "Body":
            entrada = "B"
            break;
        }

        const payload = {
          entrada: entrada,
          tipo: tipo,
          nome: nome,
          obrigatorio: this.atributo.obrigatorio,
          formato: this.atributo.formato,
          lista: this.atributo.lista,
          descricao: descricao,
          dominio: this.tempDominio,
          observacao: this.tempObservacao
        };
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-atributo/${idServicoApi}/${indexPai}`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Parâmetro salvo com sucesso!");
          this.$emit('onActionAtribute', 'rest');
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao salvar o parâmetro:", error);
      }
    },
    async openModalAddParametros(tipo, idServicoApi, indexPai) {
      this.requestType = tipo ? tipo : "";

      if (indexPai === -1) this.requestType = "";

      this.atributo.idServicoApi = idServicoApi || "";
      this.atributo.indexPai = indexPai !== null ? indexPai : "";
      this.atributo.disabledTipo = tipo !== "";
      this.showModalAddParametros = true;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          this.resetForm();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async openModalEditarParametros(tipo, idServicoApi, modalData) {
      switch (tipo) {
        case 'Entrada':
          tipo = 'E';
          break;
        case 'Header':
          tipo = 'H';
          break;
        case 'Get':
          tipo = 'G';
          break;
        case 'Saida':
          tipo = 'S';
          break;
        case 'Alerta':
          tipo = 'W';
          break;
        case 'Erro':
          tipo = 'U';
          break;
        case 'Body':
          tipo = 'B';
          break;
        default:
          break;
      }

      this.requestType = tipo ? tipo : "";

      this.showModalEditParametros = true;
      this.atributo = modalData;
      this.atributo.idServicoApi = idServicoApi;
      this.atualDataEditParametros = modalData;

      this.tempTipo = this.atributo.tipo;
      this.tempNome = this.atributo.nome;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-edit-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          $("#formato").val(this.atributo.formato);

          this.validarTipo('tipoAutenticacaoSelect');
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error);
      }
    },
    async excluirAgrupamento(idServicoApi, index) {
      this.removerAtributo(idServicoApi, index)

    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
    },
    async resetForm() {
      // Resetando os campos <select>
      $('#tipoAutenticacao').val('Selecione');
      // Resetando os campos <select>
      $('#tipoAutenticacaoSelect').val('Selecione');
      $('#tipoAutenticacaoSelectAdicionar').val('Selecione');
      // Resetando os campos <select>
      $('#formato').val('Selecione');
      $('#formatoAdicionar').val('Selecione');

      // Resetando os campos de <input> e <textarea>
      $('#descricaoModalAdicionar').val('');
      $('#dominioModalAdicionar').val('');
      $('#observacaoModalAdicionar').val('');

      $('#nomeModalAdicionar').val('');

      $('#obrigatorioId').val('');

      $('#formato').val('');

      $('#listaId').val('');

      $('#tipoAutenticacaoSelect').val('');
    },
    async salvarFluxo(codigo, tipoFluxo) {
      if (!this.fluxoTela) {
        this.fluxoTela = {};
      }

      if (tipoFluxo === 'service') {
        this.fluxoTela.serviceAcessado = codigo;
      } else {
        this.fluxoTela.menuAcessado = codigo;
      }
    },
    async alterarIcone(iconId, tipoFluxo, codigo) {
      this.salvarFluxo(codigo, tipoFluxo);

      const iconeSetadoDown = $('#' + iconId).hasClass('fa-angle-down');
      const iconeSetadoRight = $('#' + iconId).hasClass('fa-angle-right');

      if (iconeSetadoRight === true) {
        $('#' + iconId).removeClass('fa-angle-right');

        $('#' + iconId).addClass('fa-angle-down');
      } else if (iconeSetadoDown === true) {
        $('#' + iconId).removeClass('fa-angle-down');

        $('#' + iconId).addClass('fa-angle-right');
      }
    },
   async buscarServico(idServico) {
      const urlApi =
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/' + idServico;

      try {
        const response = await fetch(urlApi, { method: 'GET' });

        if (!response.ok) {
          throw new Error('Fechar');
        }

        const data = await response.json();

        const itemExiste = this.listaDadosServicoCampos.some(
          item => item.idServicoApi === data.idServicoApi
        );

        if (!itemExiste) {
          this.listaDadosServicoCampos.push(data);

          const novoItem = {
            id: idServico,
            atributos: data.atributos
          };

          this.listaDadosServicoAtributos.push(data.atributos);
          this.listaDadosServicoAtributosHierarquia.push(novoItem);
        }

        return data;
      } catch (error) {
        console.log(error);
        alertUtils.alertError('Erro ao realizar busca:' + error);
        throw error;
      }
    },
    async pesquisarServicoMenu(idCatalogo, codigoMenu) {
      loaderUtils.addLoarder();

      if (idCatalogo != undefined) {
        let urlApi;
        let method;
        let requestOptions;

        urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/servicos/' + idCatalogo + '/' + codigoMenu;
        method = 'GET';

        requestOptions = {
          method: method
        };

        try {
          fetch(urlApi, requestOptions)
            .then(async (response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error('Fechar');
              }
            })
            .then(async (data) => {
              this.listaDadosServicos = data;

              loaderUtils.removeLoader();

              return data;
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => 'loaderUtils.removeLoader()');

        } catch (error) {
          console.error('Erro ao realizar busca:', error);
          alertUtils.alertError('Erro ao realizar busca:' + error);
        }
      }
    },
    async salvarNovoMenu() {
      try {
        this.servicoApi.idCatalogoApi = this.$route.query.idCatalogo;
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-servico`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.servicoApi)
        });

        if (response.ok) {
          const result = await response.text();
          this.closeModal();
          alertUtils.alertSuccess("Menu salvo com sucesso!");
          this.$emit('onAction', this.codigo);
        } else {
          const error = await response.text();
        }
      } catch (error) {
        console.error("Erro ao salvar o serviço:", error);
      }
    },
    async setandoVisibilidade() {
      if (this.clone === false) {
        $('.fa-trash').css("display", "none");
        $('.pen-icon').css("display", "none");
        $('.plus-icon').css("display", "none");
      } else {
        $('.fa-trash').css("display", "unset");
        $('.pen-icon').css("display", "unset");
        $('.plus-icon').css("display", "unset");
      }
    },
    getServicoAtual(codigo) {
      const servico = this.listaDadosServicoAtributosHierarquia.find(item => item.id === codigo);
      if (servico) {
        return servico;
      } else {
        return { atributos: [] }; // Retorna um objeto vazio com a propriedade atributos
      }
    }
  },
  mounted() {
    document.body.addEventListener('click', this.setandoVisibilidade);

    this.idCatalogo = this.$route.params.idCatalogo;
    if (this.idCatalogo.indexOf("-clone") != -1) {
      this.clone = true;
    }

    setTimeout(() => {
      if (this.clone === false) {
        $('.trash-icon').css("display", "none");
        $('.pen-icon').css("display", "none");
        $('.plus-icon').css("display", "none");
      }
    }, 2000); // 1000 milissegundos

    setTimeout(() => {
      if (this.clone === false) {
        $('.icon-content .plus-icon').css("display", "none");
        $('.fa-trash').css("display", "none");
        $('.plus-icon').css("display", "none");
      }
    }, 2300); // Aumentei o intervalo para evitar sobreposição

    // Acesse o hash da URL
    const hash = window.location.hash;

    // Remova a primeira barra ("/") e separe a string com base nas barras
    const idCatalogo = hash.split('/').pop();

    this.pesquisarServicoMenu(idCatalogo, this.codigoMenu);
  },
}
</script>

<style scoped>

.icon-content{
  padding: 13px 21px 14px 3px !important;
}

@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>